import { style } from '@vanilla-extract/css';

export const embla = style({
  width: '100%',
});

import { globalStyle } from '@vanilla-extract/css';

globalStyle(`${embla} .embla`, {
  maxWidth: '100%',
  margin: 'auto',
  width: '100%',
  position: 'relative',
  vars: {
    '--slide-height': 'auto',
    '--slide-size': '85%',
    '--slide-control-background-color': '#ffffff',
    '--slide-control-text-color': '#94a3b8',
    '--slide-control-border-color': '#e2e8f0',
  },
  '@media': {
    '(min-width: 768px)': {
      vars: {
        '--slide-size': '50%',
      },
    },
    '(min-width: 1024px)': {
      vars: {
        '--slide-size': '33.333333%',
      },
    },
  },
});

globalStyle(`${embla} .embla__controls__inline`, {
  display: 'flex',
  flexFlow: 'row',
  alignItems: 'center',
  columnGap: '1rem',
});

globalStyle(`${embla} .embla__viewport`, {
  paddingLeft: '2rem',
  paddingRight: '2rem',
});

globalStyle(`${embla} .embla__container`, {
  display: 'flex',
  touchAction: 'pan-y pinch-zoom',
  marginLeft: 'calc(var(--gap) * -1)',
  '@media': {
    'only screen and (--mobile)': {
      marginLeft: 'calc(var(--mobile-gap) * -1)',
    },
  },
});

globalStyle(`${embla} .embla__slide`, {
  transform: 'translate3d(0, 0, 0)',
  flex: '0 0 var(--slide-size)',
  minWidth: 0,
  paddingLeft: 'var(--gap)',
  display: 'flex',
  '@media': {
    'only screen and (--mobile)': {
      paddingLeft: 'var(--mobile-gap)',
    },
  },
});

globalStyle(`${embla} .embla__slide__number`, {
  userSelect: 'none',
});

globalStyle(`${embla} .embla__controls__overlay .embla__prev, ${embla} .embla__controls__overlay .embla__next`, {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 1,
});

globalStyle(`${embla} .embla__controls__inline .embla__prev, ${embla} .embla__controls__inline .embla__next`, {
  flexShrink: 0,
});

globalStyle(`${embla} .embla__prev, ${embla} .embla__next`, {
  width: '36px',
  height: '36px',
  backgroundColor: 'var(--post-slider-control-background-color, var(--slide-control-background-color))',
  borderRadius: '999px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid var(--post-slider-control-border-color, var(--slide-control-border-color))',
  color: 'var(--post-slider-control-text-color, var(--slide-control-text-color))',
});

globalStyle(`${embla} .embla__controls__overlay .embla__next`, {
  right: '1rem',
});

globalStyle(`${embla} .embla__controls__overlay .embla__prev`, {
  left: '1rem',
});
